import { useCallback, useRef } from 'preact/hooks';
import PropTypes from 'prop-types';
import { WandMagicSparkles } from 'flowbite-react-icons/solid';

DemoAnimationsDropdown.propTypes = {
  onChosen: PropTypes.func,
  disabled: PropTypes.bool,
};

export default function DemoAnimationsDropdown({ onChosen, disabled = false }) {
  const detailsRef = useRef();
  const handleClick = useCallback(
    (animation) => {
      onChosen(animation);
      detailsRef.current.open = false;
    },
    [onChosen]
  );

  return (
    <div className="absolute bottom-1 left-1 right-1 flex items-center justify-center z-40">
      <div className="flex-grow">
        <details
          ref={detailsRef}
          className="dropdown tooltip tooltip-right"
          data-tip="Demo Animations"
        >
          <summary
            onClick={(e) => (disabled ? e.preventDefault() : null)}
            className={`btn btn-sm btn-circle btn-ghost border-0 bg-white m-1 ${disabled ? 'bg-gray-900 text-gray-500 pointer-events-none' : 'text-secondary'}`}
          >
            <WandMagicSparkles />
          </summary>
          <ul className="menu dropdown-content bg-base-100 rounded-box z-[1] w-52 p-2 shadow">
            <li>
              <button onClick={() => handleClick('goal')}>
                Goal Met Animation
              </button>
            </li>
            <li>
              <button onClick={() => handleClick('milestone')}>
                Milestone Animation
              </button>
            </li>
          </ul>
        </details>
      </div>
    </div>
  );
}
